import { writable } from 'svelte/store';

function createUserStore() {
	const { subscribe, set, update } = writable(null);
	return {
        subscribe,
        setData: async (userData)=>{
            set(userData)
        },
		reset: () => {
            set(null);
        }
	};
}

export const userData = createUserStore();